import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-sn.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-sn.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationDetailsSnConstants } from "./create-application-details-sn.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { CreateApplicationDetailsBlConstants } from "../../bl/craate-application-details-bl/create-application-details-bl.constants";
let CreateApplicationDetailsSnComponent = class CreateApplicationDetailsSnComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRefs;
    searchApplicationsService;
    detailsForm;
    applicationDetailsFormGroupName = CreateApplicationDetailsSnConstants.APPLICATION_DETAILS_FORM_GROUP_NAME;
    descriptionFormControlName = CreateApplicationDetailsSnConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsSnConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsSnConstants.DESCRIPTION_FORM_LABEL;
    applicationTypeLabel = CreateApplicationDetailsSnConstants.APPLICATION_TYPE_FORM_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypes = [];
    validationMessages = CreateApplicationDetailsSnConstants.VALIDATION_MESSAGES;
    applicationTypeLookoutName = CreateApplicationDetailsSnConstants.APPLICATION_TYPE_LOOKOUT_NAME;
    getLookupsObservableSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        if (this.isApplicationLoadedFromTheSearchPage) {
            // loaded or it is being loaded from the search page
            this.getLookups();
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has(this.applicationTypeLookoutName)) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsBlConstants.APPLICATION_TYPE_LOOKUP_NAME);
            }
            else {
                this.getLookups();
            }
        }
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                if (lookups.length > 0) {
                    this.getLookupCompleted(lookups);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsSnConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.applicationDetailsFormGroupName);
        if (this.detailsForm.pristine) {
            this.detailsForm.enable();
            this.detailsForm.reset();
        }
    }
    getLookupCompleted(lookups) {
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypes.push(lookUpContent);
            }
        });
        this.applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set(this.applicationTypeLookoutName, this.applicationTypes);
        if (this.isApplicationLoadedFromTheSearchPage) {
            // only run when the application is loaded from the search page
            this.checkApplicationData();
        }
        this.changeDetectorRefs.detectChanges();
    }
    checkApplicationData() {
        const isFormPristine = this.detailsForm.pristine;
        const isFormUnTouched = this.detailsForm.untouched;
        const isFormInvalid = this.detailsForm.invalid;
        if (isFormPristine && isFormUnTouched && isFormInvalid) {
            this.updateFormData();
        }
    }
    updateFormData() {
        this.detailsForm.get(this.descriptionFormControlName).setValue(this.selectedApplication.description);
        this.detailsForm.get(this.applicationTypeFormControlName).setValue(this.selectedApplication.type);
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsSnComponent = __decorate([
    Component({
        selector: "app-create-application-details-sn",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsSnComponent);
export { CreateApplicationDetailsSnComponent };
